import {
  BreadcrumbTextDefault,
  BreadcrumbTextSelected,
} from '@/components/TailwindComponents/styles/breadcrumb';
import {
  ButtonPrimary,
  ButtonPrimaryDisabled,
} from '@/components/TailwindComponents/styles/button';
import { RedCheckbox } from '@/components/TailwindComponents/styles/checkbox';
import {
  PageActionItem,
  PageHeader,
  PageHeaderActions,
  PageHeaderTitle,
} from '@/components/TailwindComponents/styles/pageHeader';
import {
  TableGridCellIcon,
  TableGridRowHover,
  TableGridRowSelected,
} from '@/components/TailwindComponents/styles/tableGrid';
import {
  TabsList,
  TabsTrigger,
} from '@/components/TailwindComponents/styles/tabs';

import { Red, TextColors } from './colors';

export const MuiStyles = {
  TabsList,
  TabsTrigger,
  PageHeader,
  PageHeaderTitle,
  PageHeaderActions,
  PageActionItem,
  RedCheckbox,
  TableGridRowSelected,
  TableGridRowHover,
  TableGridCellIcon,
  BreadcrumbTextSelected,
  BreadcrumbTextDefault,
  ButtonPrimary,
  ButtonPrimaryDisabled,
};

export const TailwindStyles = {
  ButtonPrimary,
  ButtonPrimaryDisabled,
  RedCheckbox,
  colors: {
    Red,
    TextColors,
  },
};
